import React, { memo } from "react";
import { useFormikContext, getIn } from "formik";
import classnames from "classnames";
import { IPrefillData } from "../../../../../stores/formsStore";
import { IErrorMessagePartProps } from "../../models";
import { ContentAlignment } from '../../models/baseTypes';
import { getAlignmentClass } from "../../models/utils";
import { FormikErrorsEx } from '../../models/validation';
import css from "../../form.module.scss";
import AnimatedReveal from "../../../AnimatedReveal";


interface IProps extends IErrorMessagePartProps {
}


const ErrorMessagePart: React.FC<IProps> = memo(({style, alignment, id, fieldDeps}) => {

  const formik = useFormikContext<IPrefillData>();
  const errors = formik.errors as FormikErrorsEx<IPrefillData>;
  const errorMsg = (errors.$errors || {})[id];
  const hasError = !!errorMsg && (formik.submitCount > 0 || fieldDeps.some(fieldBinding => getIn(formik.touched, fieldBinding)));
  const alignmentClass = getAlignmentClass(alignment || ContentAlignment.Center);
  const classes = classnames(css.errorMsg, alignmentClass);

  return (
    <AnimatedReveal show={hasError} outerContainerClassName={css.formPart} containerStyle={{padding: '0.5em 0'}}>
      <div className={classes} style={style} >
        {/* We wrap the Markdown in a `div` so that things like multi-paragraph markdown works as expected */}
        <div dangerouslySetInnerHTML={{__html: errorMsg}} />
      </div>
    </AnimatedReveal>
  );
})

export default ErrorMessagePart;






